/* BF26 Buen Fin / Black Friday: offer window, native pack add-to-cart, automatic gift lines.
   Discounts themselves are native Shopify automatic discounts (tiers by total units of
   Fibra + Borrón + Banda, BXGY gifts); this file only keeps the cart in sync with them. */
(function () {
  if (window.CDBF) return;

  var START = Date.UTC(2026, 10, 3, 10, 58); // live as soon as published (03/11, same time as the discounts)
  var DEEP_END = Date.UTC(2026, 11, 3, 5, 59); // tiers 3+5 / 4+8 and 8+ gifts end (02/12 23:59 MX)
  var END = Date.UTC(2026, 11, 16, 5, 59);     // offer ends 15/12 23:59 MX

  /* Preview: ?bf26_now=2026-11-20T10:00 (Mexico City wall clock, UTC-6) */
  var override = null, t0 = Date.now();
  try {
    var q = new URLSearchParams(location.search).get('bf26_now') || sessionStorage.getItem('bf26_now');
    var m = q && q.match(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/);
    if (m) override = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4] + 6, +m[5]);
  } catch (e) {}
  function now() { return override !== null ? override + (Date.now() - t0) : Date.now(); }

  /* BF26-only copies of the products: the tier discounts target these, so Kaching deals on the regular pages stay untouched */
  var GROUPS = {
    fibra: [15425189216642],
    borron: [15425189249410],
    banda: [15425189282178]
  };
  /* Gift variants: hidden products priced 0 (Shopify Grow can't stack a BXGY on lines already discounted by a tier) */
  var V = { sorpresa: 57014030401922, neceser: 57014030434690, spray: 57014445375874, volcanico: 57014445441410,
    polvo: 57014445408642, tiras: 57014445474178, hielo: 57014445506946, parches: 57014445539714 };
  var GIFT = {}; for (var gk in V) GIFT[V[gk]] = 1;

  function active() { var t = now(); return t >= START && t < END; }
  function deep() { var t = now(); return t >= START && t < DEEP_END; }

  function unitsByGroup(cart) {
    var c = { fibra: 0, borron: 0, banda: 0 };
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._bf26_gift) return;
      for (var g in GROUPS) if (GROUPS[g].indexOf(it.product_id) > -1) c[g] += it.quantity;
    });
    return c;
  }

  /* Gift lines the cart should hold, as {variantId: qty} */
  function wantedGifts(c) {
    var w = {};
    var add = function (v) { w[v] = (w[v] || 0) + 1; };
    if (!active()) return w;
    if (c.fibra + c.borron + c.banda >= 3) add(V.sorpresa);
    if (c.fibra >= 5) add(V.spray);
    if (c.borron >= 5) add(V.volcanico);
    if (c.banda >= 5) add(V.hielo);
    if (deep()) {
      if (c.fibra >= 8) { add(V.polvo); add(V.neceser); }
      if (c.borron >= 8) { add(V.tiras); add(V.neceser); }
      if (c.banda >= 8) { add(V.parches); add(V.neceser); }
    }
    return w;
  }

  var nativeFetch = window.fetch.bind(window);
  function getCart() { return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return nativeFetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  var syncing = null;
  /* Add missing gift lines, drop gift lines whose tier is no longer met. Returns true if the cart changed. */
  function syncGifts() {
    if (syncing) return syncing;
    syncing = getCart().then(function (cart) {
      var units = unitsByGroup(cart);
      try { document.dispatchEvent(new CustomEvent('cdbf:cart', { detail: units })); } catch (e) {}
      var want = wantedGifts(units);
      var have = {}, updates = {}, toAdd = [];
      (cart.items || []).forEach(function (it) {
        if ((it.properties && it.properties._bf26_gift) || GIFT[it.variant_id]) have[it.variant_id] = { key: it.key, qty: (have[it.variant_id] ? have[it.variant_id].qty : 0) + it.quantity };
      });
      Object.keys(have).forEach(function (v) {
        var target = want[v] || 0;
        if (have[v].qty !== target) updates[have[v].key] = target;
      });
      Object.keys(want).forEach(function (v) {
        if (!have[v]) toAdd.push({ id: +v, quantity: want[v], properties: { _bf26_gift: '1' } });
      });
      var steps = Promise.resolve(false);
      if (Object.keys(updates).length) steps = steps.then(function () { return post('/cart/update.js', { updates: updates }).then(function () { return true; }); });
      if (toAdd.length) steps = steps.then(function () {
        return post('/cart/add.js', { items: toAdd }).then(function () { return true; }, function () { return true; });
      });
      return steps;
    }).then(function (changed) {
      syncing = null;
      if (changed && typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
      return changed;
    }, function () { syncing = null; return false; });
    return syncing;
  }

  /* Re-sync after any cart mutation made by the theme, UpCart or another app */
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(syncGifts, 350); }
  var MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (MUT.test(url)) p.then(schedule, schedule);
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (MUT.test(String(url))) this.addEventListener('loadend', schedule);
    return xo.apply(this, arguments);
  };

  /* Cart mutations made with a fetch captured before this file (UpCart) still show up as resource entries */
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) { if (MUT.test(e.name)) schedule(); });
    }).observe({ type: 'resource' });
  } catch (e) {}

  /* Add a pack: [{id, quantity}] of real variants (one line per shade) */
  function addPack(items) {
    return post('/cart/add.js', { items: items }).then(function (res) {
      if (res && res.status && res.status >= 400) throw new Error(res.description || res.message || 'error');
      return syncGifts();
    }).then(function () {
      if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
      if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
      location.href = '/cart';
    });
  }

  window.CDBF = { active: active, deep: deep, now: now, syncGifts: syncGifts, addPack: addPack, unitsByGroup: unitsByGroup, getCart: getCart, V: V, GROUPS: GROUPS };

  if (active()) {
    document.documentElement.classList.add('cd-bf26-live');
    if (!deep()) document.documentElement.classList.add('cd-bf26-light');
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(syncGifts, 800); });
    else setTimeout(syncGifts, 800);
  }
})();
